import { Backup as BackupIcon, FilterNone as FilterNoneIcon } from '@mui/icons-material'
import { Box, Button, FormHelperText, Grid, TextField, Typography } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { SyntheticEvent } from 'react'
import Dropzone from 'react-dropzone-uploader'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import 'react-dropzone-uploader/dist/styles.css'
import { IRootState } from '../../../../../../redux/types'
import { FormFieldProps } from '../../../models/novelties'

interface NoveltyAddonsTabProps extends FormFieldProps {
  handleCopyText: () => void
}

const NoveltyAddonsTab = ({ novelty, handleInputChange, handleCopyText }: NoveltyAddonsTabProps) => {
  const { t } = useTranslation(['global'])
  const { seminarlessons } = useSelector((state: IRootState) => state.seminarlesson)
  const { noveltySelected } = useSelector((state: IRootState) => state.novelty)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const isWithseminar = novelty.seminarlesson != null

  const handleAutoCompleteChange = (inputName: string) => (_: SyntheticEvent, value: any) => {
    handleInputChange(inputName, value)
  }

  const getUploadParams = ({ meta }: any) => {
    let tmpFileNames = [...novelty.fileName]
    tmpFileNames.push(meta.name)
    handleInputChange('fileName', tmpFileNames)
    return {
      url: `${import.meta.env.VITE_API_URL}/novelties/uploaddropzone/${meta.name}`
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={isWithseminar ? 7 : 12} md={isWithseminar ? 9 : 12}>
        <Autocomplete
          id="combo-box-seminarlessons"
          value={novelty.seminarlesson}
          onChange={handleAutoCompleteChange('seminarlesson')}
          options={seminarlessons}
          getOptionLabel={(option: any) => (option.id !== undefined ? option.title : '')}
          renderInput={params => (
            <TextField
              {...params}
              label={t('lesson-of-seminar')}
              variant="filled"
              InputLabelProps={{ shrink: true }}
              helperText={isWithseminar ? 'Recuerda copiar el siguiente link y ponerlo dentro de la novedad' : ''}
            />
          )}
        />
      </Grid>

      {isWithseminar && (
        <Grid item xs={12} sm={isWithseminar ? 5 : 12} md={isWithseminar ? 3 : 12}>
          <Button
            onClick={handleCopyText}
            sx={{
              backgroundColor: theme => theme.palette.success.light,
              color: theme => theme.palette.success.contrastText,
              '&:hover': {
                backgroundColor: theme => theme.palette.success.main
              }
            }}
            startIcon={<FilterNoneIcon fontSize="small" />}
          >
            <Typography variant="body2">{` Botón del seminario {mostrarSeminario}`}</Typography>
          </Button>
        </Grid>
      )}

      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          {`${t('cover-image')}*`}
        </Typography>
        <Dropzone
          getUploadParams={getUploadParams}
          maxFiles={1}
          multiple={false}
          canCancel={false}
          classNames={{
            dropzone: 'dzu-dropzone-custom',
            inputLabel: 'dzu-inputlabel-custom'
          }}
          inputContent={
            <Box display="flex" flexDirection="column" alignItems="center">
              <BackupIcon />
              {t('dropzone-text')}
            </Box>
          }
        />
        <FormHelperText error={errorForm.fileName}>{msgForm.fileName}</FormHelperText>

        {noveltySelected !== null && noveltySelected.image_url !== null && novelty.fileName.length === 0 && (
          <Box
            sx={{
              p: 1,
              display: 'grid',
              justifyContent: 'center',
              my: 2,
              borderRadius: 2,
              gridGap: 1,
              backgroundColor: '#FAFAFA'
            }}
          >
            <Typography variant="body2">{`${t('preview')}:`}</Typography>
            <img
              src={`${import.meta.env.VITE_AWS_URL}/novelties/${noveltySelected.image_url}`}
              style={{ width: '100%', height: 'auto' }}
              alt={noveltySelected.title}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  )
}

export default NoveltyAddonsTab
